import React from 'react';
import "../../App.css";

const Home = () => {
  return <div className="contentDiv">
        <img className='pokeLogo' src='https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/International_Pok%C3%A9mon_logo.svg/2560px-International_Pok%C3%A9mon_logo.svg.png' alt='Pokemon Logo' />
        <img className='pokeballLogo' src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Pok%C3%A9_Ball_icon.svg/640px-Pok%C3%A9_Ball_icon.svg.png" alt="Pokeball" />
        <h1>POKEDEX</h1>
  </div>;
};

export default Home;


